import ctl from '@netlify/classnames-template-literals';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

import { keys, pipe, reduce } from '@frontend/duck-tape';
import classNames from 'classnames';
/**
 * Important: If a change is made to this file, you might need to update the regex in settings.json/eslint config files
 */

export const mergeClasses = twMerge;

/* Concatenates the styles without handling conflicting styles */
export const concatClasses = clsx;

/* Note: Should not be used as the primary "merging" function  */
export const mergeAndConcatClasses = (...classLists: MaybeNil<ClassName>[]) => pipe(classLists, clsx, twMerge);

export const mergeAndConcatClassesObject = <T extends Record<string, string>>(
  classesObjectLeft: T,
  classesObjectRight: MaybeNil<T>,
): T => {
  if (!classesObjectRight) {
    return classesObjectLeft;
  }

  return reduce(
    keys(classesObjectLeft),
    (acc, key) => {
      return {
        ...acc,
        [key]: classesObjectRight[key as keyof typeof classesObjectRight]
          ? mergeAndConcatClasses(classesObjectLeft[key], classesObjectRight[key as keyof typeof classesObjectRight])
          : classesObjectLeft[key],
      };
    },
    classesObjectLeft,
  );
};

// TODO (ethan): Maybe make opaque type for ClassName and make it safeCss' return type
export type ClassName = string;

/* Collapses css into one line + it gives type hints */
export const safeCss = ctl;

/* Conditionally applies css class */
export const applyClass = (
  value: MaybeNil<boolean | string>,
  className: string,
  elseClassName?: MaybeUndefined<string>,
) => (value ? safeCss(className) : safeCss(elseClassName ?? ''));

export { classNames };
